import React from 'react';

// A centered message box for an ICE section with nothing to show (no rows, or a request that failed)
export const SectionEmptyState = ({ children }) => (
    <div className="section-empty-state">
        <p>{children}</p>
    </div>
);

// The message an ICE section shows when its data request failed
export const SectionErrorState = () => (
    <SectionEmptyState>
        Something went wrong, please try again or <a href="/contactus">contact us</a>.
    </SectionEmptyState>
);
